import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import GameScreenLayout from "@/components/GameScreenLayout"
import { useBattleDeckChallenge } from "@/features/battle/DeckChallengeContext"
import { formatDeckSearchModeLabel } from "@/utils/deckSearch"

export default function DeckChallengeWaitingPage() {
  const navigate = useNavigate()
  const { outgoingDeckChallenge, cancelOutgoingDeck } = useBattleDeckChallenge()

  useEffect(() => {
    if (!outgoingDeckChallenge) {
      navigate("/play/deck-builder", { replace: true })
    }
  }, [outgoingDeckChallenge, navigate])

  if (!outgoingDeckChallenge) {
    return (
      <GameScreenLayout title="Ожидание" backTo="/play/deck-builder">
        <p className="text-sm text-guardians-muted">Нет вызова</p>
      </GameScreenLayout>
    )
  }

  return (
    <GameScreenLayout title="Ожидание" backTo="/play/deck-builder">
      <div className="flex flex-col items-center py-12 text-center">
        <p className="text-lg font-medium">Ожидание ответа</p>
        <p className="mt-2 text-sm text-guardians-muted">Дуэль колодой</p>
        <p className="mt-4 text-guardians-accent">
          {formatDeckSearchModeLabel(
            outgoingDeckChallenge.deckSearchMode,
            outgoingDeckChallenge.colorRank
          )}
        </p>
        <button
          type="button"
          onClick={() => {
            cancelOutgoingDeck()
            navigate(-1)
          }}
          className="mt-10 rounded-xl border border-white/20 px-6 py-2.5 text-sm"
        >
          Отменить вызов
        </button>
      </div>
    </GameScreenLayout>
  )
}
